import type { CSSProperties, ComponentType, SVGProps } from "react";
import { useTheme } from "@mui/material/styles";

import { logger } from "@/helpers/loggerHelper";

// Import all SVGs as React components
import DashboardIcon from "@/assets/img/icons/dashboard.svg?react";
import OverViewDashboardNavIcon from "@/assets/img/icons/overview_dashboard_nav.svg?react";
import DashboardNavIcon from "@/assets/img/icons/dashboard_nav.svg?react";
import CampReportsIcon from "@/assets/img/icons/camp_reports.svg?react";
import MenuMoreIcon from "@/assets/img/icons/menu_more.svg?react";
import DirectMailReportsIcon from "@/assets/img/icons/direct_mail_reports.svg?react";
import FileNavIcon from "@/assets/img/icons/file_nav.svg?react";
import FileIcon from "@/assets/img/icons/file.svg?react";
import LocReportsIcon from "@/assets/img/icons/loc_reports.svg?react";
import PersonIcon from "@/assets/img/svgIcons/person.svg?react";
import SubsOverviewIcon from "@/assets/img/icons/subs_overview.svg?react";
import AddSubscriptionIcon from "@/assets/img/icons/add_subscription.svg?react";
import CurrentSubscriptionIcon from "@/assets/img/icons/current_subscription.svg?react";
import ManagePaymentIcon from "@/assets/img/icons/manage_payment.svg?react";
import FeedbackIcon from "@/assets/img/icons/feedback.svg?react";
import RocketIcon from "@/assets/img/icons/rock.svg?react";
import CommentIcon from "@/assets/img/icons/comment.svg?react";
import EnvelopeIcon from "@/assets/img/icons/envelope_icon.svg?react";
import HandsetIcon from "@/assets/img/icons/handset_icon.svg?react";
import EducationCenterIcon from "@/assets/img/icons/resource-center.svg?react";
import LocationSvgIcon from "@/assets/img/icons/location_svg.svg?react";
import Campaign from "@/assets/img/svgIcons/campaign_name.svg?react";
import Channel from "@/assets/img/svgIcons/channel.svg?react";
import UniqueId from "@/assets/img/svgIcons/unique_id.svg?react";
import CampaignCalender from "@/assets/img/svgIcons/campaign _calender.svg?react";
import Money from "@/assets/img/svgIcons/money.svg?react";
import DownArrow from "@/assets/img/svgIcons/action.svg?react";
import Home from "@/assets/img/svgIcons/home.svg?react";
import Users from "@/assets/img/svgIcons/users.svg?react";
import MonthCalender from "@/assets/img/svgIcons/month_calender.svg?react";
import Wallet from "@/assets/img/svgIcons/wallet.svg?react";
import Images from "@/assets/img/svgIcons/images.svg?react";
import TrashIcon from "@/assets/img/svgIcons/trash.svg?react";
import Electric from "@/assets/img/svgIcons/electric.svg?react";
import Bucket from "@/assets/img/svgIcons/bucket.svg?react";
import ListView from "@/assets/img/svgIcons/list_view.svg?react";
import ListViewOutlined from "@/assets/img/svgIcons/list_view_outlined.svg?react";
import GridView from "@/assets/img/svgIcons/grid_view.svg?react";
import GridViewOutlined from "@/assets/img/svgIcons/grid_view_outlined.svg?react";
import Money1 from "@/assets/img/svgIcons/money1.svg?react";
import Map from "@/assets/img/svgIcons/map.svg?react";
import Email from "@/assets/img/svgIcons/email.svg?react";
import ContactIcon from "@/assets/img/svgIcons/contact_number.svg?react";
import FaqIcon from "@/assets/img/svgIcons/faq.svg?react";
import EducationalVideosIcon from "@/assets/img/svgIcons/education.svg?react";
import HelpfulContentIcon from "@/assets/img/svgIcons/helpful_content.svg?react";
import WhatsNewIcon from "@/assets/img/svgIcons/graph.svg?react";
import GreenInfo from "@/assets/img/svgIcons/green-info.svg?react";
import RequestFileIcon from "@/assets/img/svgIcons/file-icon.svg?react";
import SuccessIcon from "@/assets/img/svgIcons/success.svg?react";
import CheckCircleIcon from "@/assets/img/svgIcons/check-circle.svg?react";
import InfoCircleIcon from "@/assets/img/svgIcons/info_circle.svg?react";
import ClockIcon from "@/assets/img/svgIcons/clock.svg?react";
import TagsIcon from "@/assets/img/icons/tags.svg?react";
import DraftIcon from "@/assets/img/svgIcons/draft.svg?react";
import DraftTopRoundedIcon from "@/assets/img/svgIcons/draft_rounded_top.svg?react";
import EyeIcon from "@/assets/img/svgIcons/eye.svg?react";
import TimePlusIcon from "@/assets/img/svgIcons/time_plus.svg?react";
import SettingsVerticalIcon from "@/assets/img/svgIcons/setting_vertical.svg?react";
import BulbPinkIcon from "@/assets/img/svgIcons/bulb_pink.svg?react";
import ThreeDotsIcon from "@/assets/img/svgIcons/three_dots.svg?react";
import InfoCircleIconI from "@/assets/img/svgIcons/info-circle-i.svg?react";
import NoImageIcon from "@/assets/img/svgIcons/NoImage.svg?react";
import CottageIcon from "@/assets/img/svgIcons/cottage.svg?react";
import CameraIcon from "@/assets/img/svgIcons/camera.svg?react";
import SkeletonImgIcon from "@/assets/img/svgIcons/skeleton_img.svg?react";
import TemplateIcon from "@/assets/img/svgIcons/template.svg?react";
import MailTypeIcon from "@/assets/img/svgIcons/mail_type.svg?react";
import SheltrIcon from "@/assets/img/svgIcons/sheltr.svg?react";
import CreateNewPasswordIcon from "@/assets/img/svgIcons/create_new_password.svg?react";
import CampaignNotAuthorizedIcon from "@/assets/img/svgIcons/campaign_not_authorized.svg?react";
import LocationListingEditIcon from "@/assets/img/svgIcons/location_listing_edit.svg?react";
import LocationReportIcon from "@/assets/img/svgIcons/location_report.svg?react";
import UserManagementNavIcon from "@/assets/img/svgIcons/user_management_nav.svg?react";
import UserAddIcon from "@/assets/img/svgIcons/user_add.svg?react";

const iconMap = {
  dashboard: DashboardIcon,
  overview_dashboard_nav: OverViewDashboardNavIcon,
  dashboard_nav: DashboardNavIcon,
  camp_reports: CampReportsIcon,
  trash: TrashIcon,
  menu_more: MenuMoreIcon,
  direct_mail_reports: DirectMailReportsIcon,
  file_nav: FileNavIcon,
  loc_reports: LocReportsIcon,
  person: PersonIcon,
  subs_overview: SubsOverviewIcon,
  add_subscription: AddSubscriptionIcon,
  current_subscription: CurrentSubscriptionIcon,
  manage_payment: ManagePaymentIcon,
  feedback: FeedbackIcon,
  rocket: RocketIcon,
  file: FileIcon,
  comment: CommentIcon,
  envelope_icon: EnvelopeIcon,
  handset_icon: HandsetIcon,
  resource_center: EducationCenterIcon,
  location_mark: LocationSvgIcon,
  campaign: Campaign,
  channel: Channel,
  unique_id: UniqueId,
  campaign_calender: CampaignCalender,
  money: Money,
  down_arrow: DownArrow,
  home: Home,
  users: Users,
  month_calender: MonthCalender,
  wallet: Wallet,
  images: Images,
  electric: Electric,
  bucket: Bucket,
  list_view: ListView,
  list_view_outlined: ListViewOutlined,
  grid_view: GridView,
  grid_view_outlined: GridViewOutlined,
  money1: Money1,
  map: Map,
  email: Email,
  contact_icon: ContactIcon,
  faq: FaqIcon,
  educational_videos: EducationalVideosIcon,
  helpful_content: HelpfulContentIcon,
  whats_new: WhatsNewIcon,
  green_info: GreenInfo,
  info_circle: InfoCircleIcon,
  file_icon: RequestFileIcon,
  success_icon: SuccessIcon,
  checked_circle: CheckCircleIcon,
  info_circle_i: InfoCircleIconI,
  clock: ClockIcon,
  tags: TagsIcon,
  draft: DraftIcon,
  draft_top_rounded: DraftTopRoundedIcon,
  eye: EyeIcon,
  time_plus: TimePlusIcon,
  setting_vertical: SettingsVerticalIcon,
  bulb_pink: BulbPinkIcon,
  three_dots: ThreeDotsIcon,
  no_image: NoImageIcon,
  cottage: CottageIcon,
  camera: CameraIcon,
  skeleton_img: SkeletonImgIcon,
  template: TemplateIcon,
  mail_type: MailTypeIcon,
  sheltr: SheltrIcon,
  create_new_password: CreateNewPasswordIcon,
  campaign_not_authorized: CampaignNotAuthorizedIcon,
  location_listing_edit: LocationListingEditIcon,
  location_report: LocationReportIcon,
  user_management_nav: UserManagementNavIcon,
  user_add: UserAddIcon,
} satisfies Record<string, ComponentType<SVGProps<SVGSVGElement>>>;

export type RpSvgIconName = keyof typeof iconMap;

type RpSvgIconProps = Omit<SVGProps<SVGSVGElement>, "color" | "name"> & {
  name: RpSvgIconName | string;
  color?: string;
  size?: number | string;
  className?: string;
  style?: CSSProperties;
};

const RpSvgIcon = ({
  name,
  color,
  size = 22,
  className = "",
  style = {},
  ...props
}: RpSvgIconProps) => {
  const theme = useTheme();
  const Icon = iconMap[name as RpSvgIconName];

  if (!Icon) {
    logger.error(`Icon not found: ${name}`);
    return null;
  }

  const iconColor = color
    ? ((
        theme.palette as unknown as Record<
          string,
          { main?: string } | undefined
        >
      )?.[color]?.main ?? color)
    : undefined;

  return (
    <Icon
      style={{
        width: size,
        height: size,
        color: iconColor,
        ...style,
      }}
      className={className}
      {...props}
    />
  );
};

export default RpSvgIcon;
